function n(c, e) {
  return e ? c * (1e3 / e) : 0;
}
export {
  n as velocityPerSecond
};
